<!-- toggle-button.component.html -->
<div class="toggle-buttons">
    <button class="grid-button" [class.active]="isGridView" (click)="selectView('grid')" [attr.id]="'go-gridview-toggle'" [attr.data-test]="'go-gridview-toggle'">
        <img [src]="isGridView ? '../../../../assets/organisation/icon-tiles-active.svg' : '../../../../assets/organisation/icon-tiles.svg'" alt="Grid View" title="Grid View" />
    </button>
    <button class="list-button" [class.active]="!isGridView" (click)="selectView('list')" [attr.id]="'go-listview-toggle'" [attr.data-test]="'go-listview-toggle'">
        <img [src]="!isGridView ? '../../../../assets/organisation/icon-list-active.svg' : '../../../../assets/organisation/icon-list.svg'" alt="List View" title="List View" />
    </button>
</div>
